import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom/cjs/react-router-dom.min';
import { getUser, removeUserSession } from '../../utils/Common';
const FloatNavigationMeu = ({ ...p }) => {
    const user = getUser();
    useEffect(() => {

    }, []);

    const redirect = (ruta) => {
        console.log(ruta);
        p.history.push(ruta);
    }
    const cerrarDesdePadre = (e) => {
        const padre = document.getElementById('padre66');
        const hijo = document.getElementById('hijo66');
        if (padre && hijo && !hijo.contains(e.target)) { p.close(); }
    }

    return (
        <div className='vh-100 vw-100 p-2 m-0 blur-l contenedor' style={{ position: 'fixed', top: 0, left: 0, zIndex: '99999', }} onClick={cerrarDesdePadre} id='padre66'>
            <div className='row justify-content-center m-0 p-0'>
                <div className='w-100 text-end pb-3'>
                    <button className='btn btn-sm btn-danger shadow scale-1 round-xxl border border-3 border-dark text-bold text-m p-0 bw-200'
                        style={{ letterSpacing: '1.5px' }}
                        onClick={() => { p.close() }}>Cerrar panel</button>
                </div>
                <div className='col-lg-8 p-3 white-50 shadow round-s border'>
                    <div className='row justify-content-center m-0 p-0'>

                        <div className='col-lg-12 m-0 p-1 text-center' style={{ overflow: 'auto', maxHeight: '85vh' }} id='hijo66'>
                            <div className='row justify-content-evenly m-0 p-0'>
                                <NavLink className="text-bold text-dark text-center w-100 m-0 p-0" to={'/dashboard'} onClick={() => { p.close() }}>
                                    <div className='row justify-content-center m-0 p-0'>
                                        <div className={'w-90 p-1 h4 text-bold text-center m-1 mb-2 round-s scale-1 pointer  white-50 shadow text-dark'}
                                        >inicio <i className="fas fa-home fa-fw ms-2 fs-3 text-primary" /></div>
                                    </div>
                                </NavLink>
                                {
                                    user.menus.map((menu, i) => {
                                        if (menu.url && menu.url !== "#") {
                                            return (
                                                <NavLink key={"meni" + i} className="ain-item-menu mt-2 mb-3 p-1 round-s shadow contenedor scale-05 border select-color-old pointer " to={menu.url} onClick={() => { p.close() }}>
                                                    <div className={'w-90 p-1 text-center shadow-sm m-1 mb-2 round-s scale-05 pointer select-color'}
                                                    ><div className='col-lg-12 text-center h4 text-300 '>{menu.nombre}</div></div>
                                                </NavLink>
                                            )
                                        }
                                        return (
                                            <div key={"meni" + i} className={'main-item-menu mt-2 mb-3 p-1 round-s shadow contenedor ' + (
                                                menu.subMenus.length === 0 ? ' scale-05 border select-color-old pointer ' : " bg-white border"
                                            )}>
                                                <div className={'row justify-content-center m-0 p-0'}>
                                                    <div className='col-lg-12 text-center h4 text-300 '>{menu.nombre}</div>
                                                    {menu.subMenus.length > 0 && <div className='col-lg-12 m-0 p-0 '>
                                                        <div className='row justify-content-evenly m-0 p-0 w-100'>
                                                            {
                                                                menu.subMenus.map((sub, j) => {
                                                                    return (
                                                                        <NavLink key={"mddffeni" + j} className="text-bold text-dark text-center w-100 m-0 p-0" to={sub.url} onClick={() => { p.close() }}>
                                                                            <div className='row justify-content-center m-0 p-0'>
                                                                                <div className={'w-90 p-1 text-center shadow-sm m-1 mb-2 round-s scale-05 pointer select-color' + (menu.nombre.toLowerCase() === 'vivero' ? '' : '-old')} key={'uri' + j}
                                                                                >{sub.nombre}</div>
                                                                            </div>
                                                                        </NavLink>
                                                                    )
                                                                })
                                                            }
                                                        </div>
                                                    </div>}

                                                </div>
                                            </div>
                                        )
                                    })
                                }
                                <div className={"main-item-menu mt-2 mb-3 p-1 round-s shadow contenedor bg-white border"}>
                                    <NavLink className="text-bold text-dark text-center w-100 m-0 p-0" to={'/login'} onClick={() => {
                                        removeUserSession();
                                    }}>
                                        <div className='row justify-content-center m-0 p-0'>
                                            <div className={'w-90 p-1 h4 text-center shadow-sm m-1 mb-2 round-s scale-05 pointer bg-danger text-white'}
                                            >Cerrar sesión</div>
                                        </div>
                                    </NavLink>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default FloatNavigationMeu; 